<script setup lang="ts">
import { Option } from "@/types/Option";
import NovaButton from "@/ui-kit/NovaButton/NovaButton.vue";
import NovaButtonIcon from "@/ui-kit/NovaButtonIcon/NovaButtonIcon.vue";
import NovaCheckboxGroup from "@/ui-kit/NovaCheckboxGroup/NovaCheckboxGroup.vue";
import NovaInputText from "@/ui-kit/NovaInputText/NovaInputText.vue";
import NovaModal from "@/ui-kit/NovaModal/NovaModal.vue";
import { onClickOutside } from "@vueuse/core";

const props = defineProps<{ isOpen: boolean; options: Option[]; modelValue: string[] }>();
const show = defineModel<boolean>("isOpen", { required: true });
const appliedOptions = defineModel<string[]>("modelValue", { required: true });
const selectedOptions = ref(appliedOptions.value);
const searchQuery = ref("");
const filteredOptions = computed(() => {
  return props.options.filter((option) => option.label.toLowerCase().includes(searchQuery.value.toLowerCase()));
});

const handleSave = () => {
  appliedOptions.value = selectedOptions.value;

  show.value = false;
};

const handleClearAll = () => {
  appliedOptions.value = [];
  selectedOptions.value = [];

  show.value = false;
};
const component = ref(null);

watch(show, () => {
  if (show.value === false) {
    searchQuery.value = "";
  }
});

onClickOutside(component, () => (show.value = false));
</script>

<template>
  <NovaModal :show>
    <div ref="component" class="w-[640px]">
      <section class="p-4">
        <span class="flex items-center justify-between mb-2">
          <span></span>
          <h2>{{ $t("experience.health-and-safety-modal-title") }}</h2>
          <NovaButtonIcon
            name="close"
            shape="square"
            :size="16"
            theme="dark"
            data-testid="health-and-safety-modal-close-btn"
            @click="show = false"
          />
        </span>
        <div class="mx-2 bg-neutral-10 flex items-center p-2 rounded-md">
          <NovaInputText
            id="premade-modal-search-bar"
            v-model="searchQuery"
            left-icon="search"
            :placeholder="$t('experience.health-and-safety-modal-searchbar.placeholder')"
          />
        </div>
        <div class="mx-4 mt-4 h-[308px] overflow-y-scroll">
          <NovaCheckboxGroup v-model="selectedOptions" :options="filteredOptions" />
        </div>
      </section>
      <div class="border-t px-6 py-4 flex items-center justify-between">
        <NovaButton
          size="xs"
          variant="underlined"
          data-testid="health-and-safety-modal-clear-all"
          @click="handleClearAll"
        >
          {{ $t("common.clear.all_selected") }}
        </NovaButton>
        <NovaButton data-testid="health-and-safety-modal-save" size="xs" @click="handleSave">
          {{ $t("common.save") }}
        </NovaButton>
      </div>
    </div>
  </NovaModal>
</template>
